import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class InviteModel extends ModeModelBase {
  override _name = 'invite';
  override belongsTo = 'account';
  override parentIdAttribute = 'username';
}

@Injectable({ providedIn: 'root' })
export class InviteModelAccessor extends ModelAccessorBase<InviteModel> {
  override name = 'invite';
  override parentModel = 'account';
  override parentIdAttribute = 'username';

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.invite');
  }

  createModel(resource, opts?) {
    const model = new InviteModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
